(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--announcement-bar"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-announcement-bar-section')){
  class StackAnnouncementBarSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.blocks = null;
      this.autoRotate = false;
      this.displayDuration = 5000;
      this.currentIndex = 0;
      this.rotationInterval = null;
      this.countdownIntervals = [];
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack){
        setTimeout(()=>{
          if(!window.stack){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      this.blocks = this.querySelectorAll('.stack--announcement-bar-block');
      if (this.blocks.length <= 1) return;

      this.autoRotate = this.dataset.autoRotate === 'true';
      this.displayDuration = parseInt(this.dataset.displayDuration) || 5000;

      this.initCountdownTimers();
      this.initCopyButtons();
      this.initNavigation();
      this.initHoverControls();
      this.startRotation();

      this.initialized = true;
    }

    showBlock(index) {
      this.blocks.forEach((block, i) => {
        block.classList.toggle('stack--announcement-bar-active', i === index);
      });
      this.currentIndex = index;
    }

    nextBlock() {
      const nextIndex = (this.currentIndex + 1) % this.blocks.length;
      this.showBlock(nextIndex);
    }

    prevBlock() {
      const prevIndex = this.currentIndex === 0 ? this.blocks.length - 1 : this.currentIndex - 1;
      this.showBlock(prevIndex);
    }

    startRotation() {
      this.stopRotation();
      if (this.autoRotate) {
        this.rotationInterval = setInterval(() => {
          this.nextBlock();
        }, this.displayDuration);
      }
    }

    stopRotation() {
      if (this.rotationInterval) {
        clearInterval(this.rotationInterval);
        this.rotationInterval = null;
      }
    }

    initNavigation() {
      const nextBtn = this.querySelector('.stack--announcement-bar-next');
      const prevBtn = this.querySelector('.stack--announcement-bar-prev');

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          this.stopRotation();
          this.nextBlock();
          setTimeout(() => this.startRotation(), 500);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          this.stopRotation();
          this.prevBlock();
          setTimeout(() => this.startRotation(), 500);
        });
      }
    }

    initHoverControls() {
      this.addEventListener('mouseenter', () => this.stopRotation());
      this.addEventListener('mouseleave', () => this.startRotation());
    }

    initCountdownTimers() {
      const countdownElements = this.querySelectorAll('.stack--announcement-bar-time[data-target-date]');

      countdownElements.forEach(element => {
        const targetDate = new Date(element.dataset.targetDate);

        const updateCountdown = () => {
          const now = new Date().getTime();
          const distance = targetDate.getTime() - now;

          if (distance < 0) {
            element.querySelector('.stack--announcement-bar-countdown').innerHTML = '0:00:00';
            return;
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          const daysEl = element.querySelector('.stack--announcement-bar-days');
          const daysSeparatorEl = element.querySelector('.stack--announcement-bar-days-separator');
          const hoursEl = element.querySelector('.stack--announcement-bar-hours');
          const minutesEl = element.querySelector('.stack--announcement-bar-minutes');
          const secondsEl = element.querySelector('.stack--announcement-bar-seconds');

          // Show/hide days based on whether there are any
          if (daysEl && daysSeparatorEl) {
            if (days > 0) {
              daysEl.style.display = 'inline';
              daysSeparatorEl.style.display = 'inline';
              daysEl.textContent = days;
            } else {
              daysEl.style.display = 'none';
              daysSeparatorEl.style.display = 'none';
            }
          }

          if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
          if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
          if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
        };

        updateCountdown();
        const intervalId = setInterval(updateCountdown, 1000);
        this.countdownIntervals.push(intervalId);
      });
    }

    initCopyButtons() {
      const discountWrappers = this.querySelectorAll('.stack--announcement-bar-discount-wrapper');

      discountWrappers.forEach(wrapper => {
        const copyButton = wrapper.querySelector('.stack--announcement-bar-copy-btn');

        if (copyButton) {
          const code = copyButton.dataset.code;
          wrapper.style.cursor = 'pointer';

          const copyToClipboard = () => {
            if (navigator.clipboard) {
              navigator.clipboard.writeText(code).then(() => {
                this.showCopyFeedback(copyButton);
              }).catch(() => {
                this.fallbackCopy(code, copyButton);
              });
            } else {
              this.fallbackCopy(code, copyButton);
            }
          };

          copyButton.addEventListener('click', (e) => {
            e.stopPropagation();
            copyToClipboard();
          });

          wrapper.addEventListener('click', (e) => {
            if (e.target !== copyButton) {
              copyToClipboard();
            }
          });
        }
      });
    }

    fallbackCopy(code, button) {
      const textArea = document.createElement('textarea');
      textArea.value = code;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        this.showCopyFeedback(button);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }

      document.body.removeChild(textArea);
    }

    showCopyFeedback(button) {
      const originalHTML = button.innerHTML;

      button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.classList.add('copied');

      setTimeout(() => {
        button.innerHTML = originalHTML;
        button.classList.remove('copied');
      }, 2000);
    }

    disconnectedCallback() {
      this.stopRotation();
      this.countdownIntervals.forEach(intervalId => clearInterval(intervalId));
      this.countdownIntervals = [];
      this.initialized = false;
    }
  }

  customElements.define('stack-announcement-bar-section', StackAnnouncementBarSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      section.init();
    }
  }
});

document.addEventListener('shopify:section:deselect', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      const blocks = section.querySelectorAll('.stack--announcement-bar-block');
      blocks.forEach(block => {
        block.style.animation = 'none';
      });
    }
  }
});

document.addEventListener('shopify:theme:section:reorder', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--before-after"] && !Shopify.designMode) return;
  try {
    
(async()=>{
  if(!customElements.get('stack-before-after-slider')){
    class StackBeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        if(!window.stack) {
          setTimeout(() => { if(!window.stack) this.remove(); else this.init(); }, 100);
          return;
        }
        this.init();
      }
      
      init() {
        if(this.initialized) return;
        this.initialized = true;
        
        this.container = this.querySelector('.stack--comparison-container');
        this.beforeImage = this.querySelector('[data-before-image]');
        this.divider = this.querySelector('[data-divider]');
        this.handle = this.querySelector('[data-handle]');
        
        if(!this.container || !this.beforeImage || !this.divider || !this.handle) return;
        
        this.position = parseInt(this.dataset.initial) || 50;
        this.isDragging = false;
        
        this.updatePosition(this.position);
        
        // Mouse events
        this.handle.addEventListener('mousedown', this.startDrag.bind(this));
        document.addEventListener('mousemove', this.onDrag.bind(this));
        document.addEventListener('mouseup', this.stopDrag.bind(this));
        
        // Touch events
        this.container.addEventListener('touchstart', this.startDrag.bind(this), {passive: true});
        document.addEventListener('touchmove', this.onTouchMove.bind(this), {passive: false});
        document.addEventListener('touchend', this.stopDrag.bind(this));
        
        // Keyboard events
        this.handle.addEventListener('keydown', this.onKey.bind(this));
      }
      
      updatePosition(percent) {
        percent = Math.max(0, Math.min(100, percent));
        this.position = percent;
        this.beforeImage.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
        this.divider.style.left = `${percent}%`;
        this.handle.style.left = `${percent}%`;
        this.handle.setAttribute('aria-valuenow', percent);
      }
      
      getPositionFromEvent(e) {
        const rect = this.container.getBoundingClientRect();
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        return ((clientX - rect.left) / rect.width) * 100;
      }
      
      startDrag(e) {
        if(e.type === 'mousedown') e.preventDefault();
        this.isDragging = true;
        this.container.classList.add('is-dragging');
      }
      
      onDrag(e) {
        if(!this.isDragging) return;
        this.updatePosition(this.getPositionFromEvent(e));
      }
      
      onTouchMove(e) {
        if(!this.isDragging) return;
        // Check if movement is mostly horizontal
        if (e.touches && e.touches.length) {
           this.updatePosition(this.getPositionFromEvent(e));
           e.preventDefault(); // Prevent scrolling while dragging slider
        }
      }
      
      stopDrag() {
        this.isDragging = false;
        this.container.classList.remove('is-dragging');
      }
      
      onKey(e) {
        if(!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault();
        if(e.key === 'ArrowLeft') this.updatePosition(this.position - 5);
        if(e.key === 'ArrowRight') this.updatePosition(this.position + 5);
        if(e.key === 'Home') this.updatePosition(0);
        if(e.key === 'End') this.updatePosition(100);
      }
    }
    customElements.define('stack-before-after-slider', StackBeforeAfterSlider);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--faq"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-faq-section')){
  class StackFAQSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.resizeTimeout = null;
      this.boundResize = this.onResize.bind(this);
    }

    connectedCallback() {
      if(!window.stack){
        setTimeout(() => { if(window.stack) this.init(); else this.remove(); }, 100);
      } else {
        requestAnimationFrame(() => this.init());
      }
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;

      const questions = this.querySelectorAll('.stack--faq-question');
      this.setHeights();

      window.addEventListener('resize', this.boundResize);

      questions.forEach(q => {
        q.addEventListener('click', this.onClick.bind(this));
      });
    }

    onResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.setHeights(), 200);
    }

    setHeights() {
      const answers = this.querySelectorAll('.stack--faq-answer');
      answers.forEach(ans => {
        const inner = ans.querySelector('.stack--faq-answer-inner');
        if(!inner) return;
        ans.style.height = (ans.getAttribute('aria-hidden') === 'false') ? inner.offsetHeight + 'px' : '0px';
      });
    }

    onClick(e) {
      const btn = e.currentTarget;
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      const targetId = btn.getAttribute('aria-controls');
      const target = document.getElementById(targetId);

      if(!target) return;
      const inner = target.querySelector('.stack--faq-answer-inner');
      if(!inner) return;

      if(isExpanded) {
        btn.setAttribute('aria-expanded', 'false');
        target.setAttribute('aria-hidden', 'true');
        target.style.height = '0px';
      } else {
        btn.setAttribute('aria-expanded', 'true');
        target.setAttribute('aria-hidden', 'false');
        target.style.height = inner.offsetHeight + 'px';

        // Close others (Accordion)
        const allBtns = this.querySelectorAll('.stack--faq-question');
        allBtns.forEach(otherBtn => {
          if(otherBtn !== btn && otherBtn.getAttribute('aria-expanded') === 'true') {
            otherBtn.setAttribute('aria-expanded', 'false');
            const otherTarget = document.getElementById(otherBtn.getAttribute('aria-controls'));
            if(otherTarget) {
              otherTarget.setAttribute('aria-hidden', 'true');
              otherTarget.style.height = '0px';
            }
          }
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundResize);
    }
  }
  customElements.define('stack-faq-section', StackFAQSection);
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--image-with-benefits"] && !Shopify.designMode) return;
  try {
    
(async()=>{
const el=document.querySelector('.stack--image-with-benefits');
if(!el)return;
if(!window.stack){setTimeout(()=>{if(!window.stack){el.remove()}},100);return;}
if(!window.stack){el.remove();return;}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--logo-slider"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-logo-slider-section')){
  class StackLogoSliderSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.resizeTimeout = null;
      this.boundHandleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack){
        setTimeout(()=>{
          if(!window.stack){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const marquee = this.querySelector('.stack--logo-slider-marquee');
      const tracksContainer = this.querySelector('.stack--logo-slider-tracks-container');
      
      if (!marquee || !tracksContainer) return;
      
      if (window.getComputedStyle(document.documentElement).getPropertyValue('direction') === 'rtl') {
        marquee.classList.add('stack--logo-slider-rtl');
      }
      
      this.adjustTrackCount(tracksContainer);
      
      // Setup resize listener
      window.addEventListener('resize', this.boundHandleResize);
      
      this.initialized = true;
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        const tracksContainer = this.querySelector('.stack--logo-slider-tracks-container');
        if (tracksContainer) {
          this.adjustTrackCount(tracksContainer);
        }
      }, 250);
    }

    adjustTrackCount(tracksContainer) {
      const existingTracks = tracksContainer.querySelectorAll('.stack--logo-slider-track');
      const firstTrack = existingTracks[0];
      
      if (!firstTrack) return;
      
      const screenWidth = window.innerWidth;
      const trackWidth = firstTrack.scrollWidth;
      const neededTracks = Math.max(3, Math.ceil((screenWidth * 2) / trackWidth));
      const currentTracks = existingTracks.length;
      
      if (neededTracks > currentTracks) {
        for (let i = currentTracks; i < neededTracks; i++) {
          const newTrack = firstTrack.cloneNode(true);
          newTrack.setAttribute('aria-hidden', 'true');
          
          newTrack.querySelectorAll('.stack--logo-slider-item').forEach(item => {
            item.removeAttribute('data-block-id');
            item.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
            item.querySelectorAll('img').forEach(img => img.setAttribute('alt', ''));
          });
          
          tracksContainer.appendChild(newTrack);
        }
        this.resetAnimation(tracksContainer);
      }
      
      if (neededTracks < currentTracks) {
        for (let i = currentTracks - 1; i >= neededTracks; i--) {
          if (existingTracks[i] && i > 0) {
            existingTracks[i].remove();
          }
        }
        this.resetAnimation(tracksContainer);
      }
    }

    resetAnimation(tracksContainer) {
      const tracks = tracksContainer.querySelectorAll('.stack--logo-slider-track');
      tracks.forEach(track => {
        track.style.animation = 'none';
        track.offsetHeight;
        track.style.animation = null;
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundHandleResize);
      this.initialized = false;
    }
  }

  customElements.define('stack-logo-slider-section', StackLogoSliderSection);
}

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('stack--logo-slider')) {
      const section = document.querySelector('.stack--logo-slider');
      if (section && section.tagName.toLowerCase() === 'stack-logo-slider-section') {
        setTimeout(() => section.init(), 100);
      }
    }
  });
  
  document.addEventListener('shopify:section:unload', function(event) {
    if (event.detail.sectionId.includes('stack--logo-slider')) {
      const section = document.querySelector('.stack--logo-slider');
      if (section && section.tagName.toLowerCase() === 'stack-logo-slider-section') {
        section.disconnectedCallback();
      }
    }
  });
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--product"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-product-section')){
  class StackProductSection extends HTMLElement {
    connectedCallback() {
      if(!window.stack){
        setTimeout(()=>{ if(!window.stack){ this.remove(); } else { this.init(); } },100);
        return;
      }
      this.init();
    }
    init() {
      if (this.initialized) return;
      this.initialized = true;
      this.timers = [];
      this.initLiveViewers();
      this.initDeliveryDates();
      this.initSizeCharts();
    }
    initLiveViewers() {
      this.querySelectorAll('.stack--live-viewers').forEach(el => {
        const min = parseInt(el.dataset.min, 10) || 30;
        const max = parseInt(el.dataset.max, 10) || 60;
        const count = el.querySelector('[data-viewer-count]');
        if (!count) return;
        let v = Math.floor(Math.random() * (max - min + 1)) + min;
        count.textContent = v;
        const tick = () => {
          v += (Math.floor(Math.random() * 3) + 1) * (Math.random() > 0.5 ? 1 : -1);
          v = Math.min(max, Math.max(min, v));
          count.textContent = v;
          const t = setTimeout(tick, Math.floor(Math.random() * 3000) + 5000);
          this.timers.push(t);
        };
        const t = setTimeout(tick, Math.floor(Math.random() * 3000) + 5000);
        this.timers.push(t);
      });
    }
    initDeliveryDates() {
      this.querySelectorAll('[data-delivery-date]').forEach(el => {
        try {
          const ts = parseInt(el.dataset.timestamp, 10) * 1000;
          const locale = el.dataset.locale || 'en';
          el.textContent = new Intl.DateTimeFormat(locale, { weekday: 'long', month: 'short', day: 'numeric' }).format(new Date(ts));
        } catch (e) {}
      });
    }
    initSizeCharts() {
      this.onKey = (e) => { if (e.key === 'Escape') this.closeCharts(); };
      this.querySelectorAll('.stack--size-chart').forEach(wrap => {
        const popup = wrap.querySelector('[data-size-chart-popup]');
        if (popup && popup.parentNode !== document.body) document.body.appendChild(popup);
        wrap.querySelectorAll('[data-size-chart-open]').forEach(b => b.addEventListener('click', () => this.openChart(popup)));
        if (popup) popup.querySelectorAll('[data-size-chart-close]').forEach(b => b.addEventListener('click', () => this.closeCharts()));
        wrap._popup = popup;
      });
    }
    openChart(popup) {
      if (!popup) return;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKey);
    }
    closeCharts() {
      this.querySelectorAll('.stack--size-chart').forEach(w => { if (w._popup) w._popup.hidden = true; });
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKey);
    }
    disconnectedCallback() {
      (this.timers || []).forEach(t => clearTimeout(t));
      document.removeEventListener('keydown', this.onKey);
      this.querySelectorAll('.stack--size-chart').forEach(w => { if (w._popup && w._popup.parentNode === document.body) w._popup.remove(); });
    }
  }
  customElements.define('stack-product-section', StackProductSection);
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--related-products"] && !Shopify.designMode) return;
  try {
    
(async () => {
  if (!customElements.get('stack-related-products')) {
    class StackRelatedProducts extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
      }

      connectedCallback() {
        if (!window.stack) {
          setTimeout(() => { if (window.stack) this.init(); else this.remove(); }, 100);
        } else {
          requestAnimationFrame(() => this.init());
        }
      }

      async init() {
        if (this.initialized) return;
        this.initialized = true;

        const productId = this.getAttribute('data-product-id');
        const limit = this.getAttribute('data-limit') || 4;
        const grid = this.querySelector('.stack--rp-grid');

        if (!productId || !grid) return;

        // Render Skeletons
        grid.innerHTML = Array.from({ length: limit }).map(() => `
          <div class="stack--rp-skeleton-card">
            <div class="stack--rp-image-wrapper"></div>
            <div class="stack--rp-info">
              <div class="stack--rp-skeleton-title"></div>
              <div class="stack--rp-skeleton-price"></div>
            </div>
          </div>
        `).join('');

        try {
          const response = await fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limit}`);
          if (!response.ok) throw new Error('Network response was not ok');
          const data = await response.json();
          const products = data.products;

          if (products && products.length > 0) {
            grid.innerHTML = products.map(product => this.renderProductCard(product)).join('');
          } else {
            // Hide section if no recommendations
            this.style.display = 'none';
          }
        } catch (error) {
          console.error('Error fetching related products:', error);
          this.style.display = 'none';
        }
      }

      renderProductCard(product) {
        const image = product.featured_image ? product.featured_image : '';
        const hoverImage = product.images.length > 1 ? product.images[1] : image;
        
        // Format money (basic formatter since we don't have liquid filter here)
        const formatMoney = (cents) => {
          return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify.currency.active });
        };

        const price = formatMoney(product.price);
        const comparePrice = product.compare_at_price > product.price ? formatMoney(product.compare_at_price) : null;

        return `
          <a href="${product.url}" class="stack--rp-card">
            <div class="stack--rp-image-wrapper">
              ${image ? `<img src="${image}" alt="${product.title}" class="stack--rp-image" loading="lazy">` : ''}
              ${hoverImage && hoverImage !== image ? `<img src="${hoverImage}" alt="${product.title}" class="stack--rp-image stack--rp-image-hover" loading="lazy">` : ''}
            </div>
            <div class="stack--rp-info">
              <h3 class="stack--rp-title">${product.title}</h3>
              <div class="stack--rp-price">
                ${comparePrice ? `<span class="stack--rp-price-compare">${comparePrice}</span>` : ''}
                <span>${price}</span>
              </div>
            </div>
          </a>
        `;
      }
    }
    customElements.define('stack-related-products', StackRelatedProducts);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--shoppable-slides"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-shoppable-slides-section')){
class StackShoppableSlidesSection extends HTMLElement {
constructor() {
super();
this.initialized = false;
this.swiper = null;
this.currentlyPlayingVideo = null;
}

connectedCallback() {
if(!window.stack){
setTimeout(()=>{
 if(!window.stack){
   this.remove();
 } else {
   this.init();
 }
},100);
return;
}
requestAnimationFrame(() => this.init());
}

init() {
if (this.initialized) return;

// Add initial load class for animation
if (this.classList.contains('stack--shoppable-slides-fade')) {
this.classList.add('stack--shoppable-slides-initial-load');
// Remove after animation completes
setTimeout(() => {
 this.classList.remove('stack--shoppable-slides-initial-load');
}, 1500);
}

this.initSwiperSlider();
this.initVideoControls();

this.initialized = true;
}

initSwiperSlider() {
const swiperContainer = this.querySelector('.stack--shoppable-slides-swiper');
if (!swiperContainer) return;

// Wait for Swiper library to load
if (typeof Swiper === 'undefined') {
setTimeout(() => this.initSwiperSlider(), 100);
return;
}

const autoplayEnabled = this.dataset.autoplay === 'true';
const coverflowEnabled = this.dataset.coverflow === 'true';
const swiperId = swiperContainer.id;

// Initialize Swiper configuration
const swiperConfig = {
grabCursor: true,
centeredSlides: true,
slidesPerView: 'auto',
spaceBetween: 20,
loop: true,
loopAddBlankSlides: true,
loopAdditionalSlides: 3,
speed: 600,

// Navigation (scoped to this specific swiper)
navigation: {
 nextEl: this.querySelector('.swiper-button-next'),
 prevEl: this.querySelector('.swiper-button-prev'),
},

// Autoplay (optional)
...(autoplayEnabled && {
 autoplay: {
   delay: 5000,
   disableOnInteraction: false,
   pauseOnMouseEnter: true,
 },
}),

// Coverflow effect (optional)
...(coverflowEnabled && {
 effect: 'coverflow',
 coverflowEffect: {
   rotate: 0,
   stretch: 0,
   depth: 85,
   modifier: 1,
   slideShadows: true,
 },
}),

// Accessibility
a11y: {
 enabled: true,
 prevSlideMessage: 'Previous video',
 nextSlideMessage: 'Next video',
 firstSlideMessage: 'This is the first video',
 lastSlideMessage: 'This is the last video',
},

// Keyboard control
keyboard: {
 enabled: true,
 onlyInViewport: true,
},

// Responsive breakpoints
breakpoints: {
 1024: {
   spaceBetween: 50,
 },
 768: {
  spaceBetween: 40,
 }
},

// Prevent animation on init
runCallbacksOnInit: false,

// On slide change, stop all videos
on: {
 slideChange: () => {
   this.stopAllVideos();
 },
},
};

// Initialize Swiper with unique ID
this.swiper = new Swiper(`#${swiperId}`, swiperConfig);
}

initVideoControls() {
const slides = this.querySelectorAll('.swiper-slide');

slides.forEach((slide) => {
 const video = slide.querySelector('.stack--shoppable-slides-video');
 const playButton = slide.querySelector('.stack--shoppable-slides-play-button');
 const playIcon = slide.querySelector('#iconPlay');
 const pauseIcon = slide.querySelector('#iconPause');

 if (!video || !playButton || !playIcon || !pauseIcon) return;

 // Play/Pause on button click
 playButton.addEventListener('click', (e) => {
   e.stopPropagation();
   
   // Only allow interaction on active, prev, or next slides
   if (
     slide.classList.contains('swiper-slide-active') ||
     slide.classList.contains('swiper-slide-next') ||
     slide.classList.contains('swiper-slide-prev')
   ) {
     // Stop other videos first
     if (this.currentlyPlayingVideo && this.currentlyPlayingVideo !== video) {
       this.stopVideo(this.currentlyPlayingVideo);
     }

     // Toggle current video
     if (video.paused) {
       video.volume = 0.4;
       video.play();
       playIcon.style.display = 'none';
       pauseIcon.style.display = 'block';
       playButton.setAttribute('aria-label', 'Pause video');
       this.currentlyPlayingVideo = video;
     } else {
       this.stopVideo(video);
     }
   }
 });

 // Reset video when it ends
 video.addEventListener('ended', () => {
   video.currentTime = 0;
   playIcon.style.display = 'block';
   pauseIcon.style.display = 'none';
   playButton.setAttribute('aria-label', 'Play video');
   if (this.currentlyPlayingVideo === video) {
     this.currentlyPlayingVideo = null;
   }
 });
});
}

stopVideo(video) {
if (!video) return;

const slide = video.closest('.swiper-slide');
if (!slide) return;

const playIcon = slide.querySelector('#iconPlay');
const pauseIcon = slide.querySelector('#iconPause');
const playButton = slide.querySelector('.stack--shoppable-slides-play-button');

video.pause();
if (playIcon) playIcon.style.display = 'block';
if (pauseIcon) pauseIcon.style.display = 'none';
if (playButton) playButton.setAttribute('aria-label', 'Play video');

if (this.currentlyPlayingVideo === video) {
 this.currentlyPlayingVideo = null;
}
}

stopAllVideos() {
const videos = this.querySelectorAll('.stack--shoppable-slides-video');
videos.forEach(video => this.stopVideo(video));
}

disconnectedCallback() {
// Cleanup Swiper instance
if (this.swiper && this.swiper.destroy) {
this.swiper.destroy(true, true);
}
this.stopAllVideos();
this.initialized = false;
}
}

customElements.define('stack-shoppable-slides-section', StackShoppableSlidesSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
if (event.detail.sectionId.includes('stack--shoppable-slides')) {
const section = document.querySelector('stack-shoppable-slides-section');
if (section) {
setTimeout(() => section.init(), 100);
}
}
});

document.addEventListener('shopify:section:select', function(event) {
if (event.detail.sectionId.includes('stack--shoppable-slides')) {
const section = document.querySelector('stack-shoppable-slides-section');
if (section) {
section.init();
}
}
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--stats-benefits"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-stats-benefits-section')){
  class StackStatsBenefitsSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.observer = null;
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack){
        setTimeout(()=>{
          if(!window.stack){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const counters = this.querySelectorAll('.stack--stats-benefits-counter');
      const observerOptions = {
        threshold: 0.5,
        rootMargin: '0px 0px -50px 0px'
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !entry.target.dataset.animated) {
            this.animateCounter(entry.target);
            entry.target.dataset.animated = 'true';
          }
        });
      }, observerOptions);

      counters.forEach(counter => {
        this.observer.observe(counter);
      });

      this.initialized = true;
    }

    animateCounter(counter) {
      const from = parseInt(counter.dataset.from) || 0;
      const to = parseInt(counter.dataset.to) || 0;
      const duration = parseInt(counter.dataset.duration) || 2000;
      
      if (from === to) return;
      
      const startTime = performance.now();
      const difference = to - from;
      
      const updateCounter = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        const easeOut = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.round(from + (difference * easeOut));
        
        counter.textContent = currentValue;
        
        if (progress < 1) {
          requestAnimationFrame(updateCounter);
        } else {
          counter.textContent = to;
        }
      };
      
      requestAnimationFrame(updateCounter);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      this.initialized = false;
    }
  }

  customElements.define('stack-stats-benefits-section', StackStatsBenefitsSection);
}

// Handle Shopify theme editor events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('stack--stats-benefits')) {
      const section = document.querySelector('.stack--stats-benefits');
      if (section && section.tagName.toLowerCase() === 'stack-stats-benefits-section') {
        setTimeout(() => section.init(), 100);
      }
    }
  });
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--sticky-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stack-sticky-cart')) {
  class StackStickyCart extends HTMLElement {
    constructor() {
      super();
      this.behavior = this.dataset.behavior || 'atc';
      this.button = this.querySelector('[data-action-button]');
      this.select = this.querySelector('[data-variant-select]');
      this.hasScrolled = false;
    }

    connectedCallback() {
      if (this.button) {
        this.button.addEventListener('click', this.handleAction.bind(this));
      }
      
      // Simple scroll listener to show the sticky cart
      window.addEventListener('scroll', () => {
        if (window.scrollY > 400 && !this.hasScrolled) {
          this.classList.add('is-visible');
          this.hasScrolled = true;
        } else if (window.scrollY <= 400 && this.hasScrolled) {
          this.classList.remove('is-visible');
          this.hasScrolled = false;
        }
      }, { passive: true });
    }

    handleAction(e) {
      e.preventDefault();
      
      if (this.behavior === 'scrollup') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        // Add to cart behavior
        const variantId = this.select ? this.select.value : null;
        if (!variantId) return;

        // Use Shopify cart API or theme's cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.addItemToCart === 'function') {
          cartDrawer.addItemToCart(variantId);
        } else {
          // Fallback to standard fetch
          const formData = {
            'items': [{
              'id': variantId,
              'quantity': 1
            }]
          };
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(data => {
            window.location.href = window.Shopify.routes.root + 'cart';
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      }
    }
  }
  customElements.define('stack-sticky-cart', StackStickyCart);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--story-menu"] && !Shopify.designMode) return;
  try {
    
(async()=>{
const el=document.querySelector('.stack--stories');
if(!el)return;
if(!window.stack){setTimeout(()=>{if(!window.stack){el.remove()}},100);return;}
if(!window.stack){el.remove();return;}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--video-carousel"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-video-carousel-section')){
  class StackVideoCarouselSection extends HTMLElement {
    connectedCallback() {
      if(!window.stack){
        setTimeout(()=>{ if(!window.stack){ this.remove(); } else { this.init(); } },100);
        return;
      }
      this.init();
    }
    init() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('.stack--video-carousel-play').forEach(btn => {
        btn.addEventListener('click', () => this.playVideo(btn.closest('.stack--video-carousel-item')));
      });
    }
    playVideo(item) {
      if (!item || item.classList.contains('is-playing')) return;
      const poster = item.querySelector('.stack--video-carousel-poster');
      const tpl = item.querySelector('.stack--video-carousel-template');
      if (!poster || !tpl) return;
      const node = tpl.content.cloneNode(true);
      poster.innerHTML = '';
      poster.appendChild(node);
      item.classList.add('is-playing');
      const video = poster.querySelector('video');
      if (video) { video.play().catch(() => {}); }
    }
  }
  customElements.define('stack-video-carousel-section', StackVideoCarouselSection);
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--video-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stack-video-testimonials')) {
  class StackVideoTestimonials extends HTMLElement {
    constructor() {
      super();
      this.videos = this.querySelectorAll('video');
      this.playBtns = this.querySelectorAll('.stack--vt-play-btn');
    }

    connectedCallback() {
      this.playBtns.forEach((btn, index) => {
        btn.addEventListener('click', () => {
          const video = this.videos[index];
          if (video) {
            // Pause all other videos
            this.videos.forEach(v => {
              if (v !== video) {
                v.pause();
                v.classList.remove('is-playing');
              }
            });

            // Play this video
            video.classList.add('is-playing');
            video.play();
          }
        });
      });

      this.videos.forEach(video => {
        video.addEventListener('pause', () => {
          video.classList.remove('is-playing');
        });
        video.addEventListener('ended', () => {
          video.classList.remove('is-playing');
        });
      });
    }
  }
  customElements.define('stack-video-testimonials', StackVideoTestimonials);
}

  } catch(e) { console.error(e); }
})();
})();
